var map = {
	"./ROBOINU-Logo-Rocket1-tm.svg": 38257,
	"./ROBOINU-Logo-Rocket1.svg": 40919,
	"./ROBOINU-Network1.svg": 75207,
	"./ROBOINU-RGB-Community.svg": 57061,
	"./ROBOINU-RGB-Network2.svg": 95458,
	"./ROBOINU-RGB-RoboLaunchpad.svg": 12338,
	"./ROBOINU-RGB-RoboMarket.svg": 8514,
	"./ROBOINU-RGB-RoboVentures.svg": 49498,
	"./ROBOINU-RGB-RoboWallet.svg": 55925,
	"./ROBOINU-RGB-Rocket1.svg": 49971,
	"./ROBOINU-RGB-RocketTrail1.svg": 61743,
	"./ROBOINU-RGB-RocketTrail2.svg": 82716,
	"./ROBOINU-RGB-RocketTrail3.svg": 53341,
	"./ROBOINURocket1.svg": 75516,
	"./ROBOINURocket2.svg": 77839,
	"./close-circle.svg": 56590,
	"./close.svg": 91825,
	"./coin-gecko.svg": 97838,
	"./coin-market.svg": 54773,
	"./copy-done.png": 2941,
	"./copy.png": 6266,
	"./done.svg": 23067,
	"./download_android_store.svg": 15681,
	"./download_ios_store.svg": 34855,
	"./exchange.svg": 13296,
	"./facebook.svg": 27355,
	"./footer-logo-tm.svg": 35022,
	"./get-started.svg": 80861,
	"./goal-business.svg": 50157,
	"./header-logo-tm.svg": 25124,
	"./instagram.svg": 56137,
	"./lauchpad-term.svg": 78920,
	"./left-arrow.svg": 27284,
	"./linkedIn.svg": 42525,
	"./loading.svg": 15829,
	"./logo-term.svg": 42373,
	"./navbar-btn.svg": 5354,
	"./new-facebook.svg": 50376,
	"./new-reddit.svg": 33664,
	"./new-telegram.svg": 46469,
	"./new-twitter.svg": 49049,
	"./pending.svg": 52588,
	"./planning-business.svg": 7879,
	"./policy.svg": 53757,
	"./problem-solving.svg": 46147,
	"./problems-bg.svg": 89617,
	"./problems.svg": 34599,
	"./right-arrow.svg": 66587,
	"./risks-bg.svg": 35183,
	"./risks.svg": 37545,
	"./robo-dao.svg": 28052,
	"./robo-ex.svg": 60843,
	"./solution-bg.svg": 25806,
	"./solution-business.svg": 52661,
	"./solution.svg": 83178,
	"./sort-left.svg": 70079,
	"./strategy-presentation.svg": 62377,
	"./telegram.svg": 88610,
	"./timer.svg": 49550,
	"./twitter.svg": 38484,
	"./youtube.svg": 54762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36869;